<template>
  <div class="main-page container-flex fill-flex-full" ref="app">
    <div class="safe-header"></div>
    <div class="safe-footer"></div>

    <div
      id="overlay"
      class="overlay"
      v-if="loggedIn"
      @click="clickOverlay"
    ></div>
    <alert-component ref="alert"></alert-component>
    <header-component v-if="loggedIn"></header-component>
    <contacts-component v-if="loggedIn"></contacts-component>
    <router-view></router-view>
    <bottom-contacts v-if="loggedIn" class="fill-flex-no" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import HeaderComponent from "./components/HeaderComponent.vue";
import AlertComponent from "./components/AlertComponent.vue";
import BottomContacts from "./components/BottomContacts.vue";
import $ from "jquery";
import _ from "lodash";
import numeral from "numeral";
import ContactsComponent from "./components/ContactsComponent.vue";

export default {
  name: "App",

  components: { HeaderComponent, BottomContacts, AlertComponent, ContactsComponent },

  computed: {
    ...mapGetters(["loggedIn"]),

    ...mapState(["payStatusSuccess", "payStatusError", "paySum"]),
  },

  methods: {
    ...mapMutations(["setToken", "setClient"]),

    ...mapActions(["paymentStatus", "fetchClient"]),

    clickOverlay() {
      $("#top-menu-toggler").toggleClass("on");
      $(".top-menu-expanded").slideToggle();
      $(".overlay").fadeToggle();
      $("body").toggleClass("no-scroll");
    },

    currency(v, { withPlus, withLabel } = {}) {
      let res = numeral(v).format("0.00");
      if (withLabel) {
        res += "\u00A0" + "₽";
      }
      if (withPlus && /^\d+$/.test(res.charAt(0)) && v !== 0) {
        res = "+" + res;
      }
      return res;
    },
  },

  mounted() {
    if (localStorage && localStorage.token) {
      this.setToken(localStorage.token);
    } else if (sessionStorage) {
      if (sessionStorage.token) {
        this.setToken(sessionStorage.token);
      }
      if (sessionStorage.client) {
        this.setClient(JSON.parse(sessionStorage.client));
      }
    }

    const paymentResultHook = () => {
      // обработка результата платежа от сбербанка
      let system = this.$route.query.system;
      if (_.isArrayLikeObject(system)) {
        system = system[0];
      }
      const act = this.$route.query.act;
      if (system === "sberbank") {
        const orderId = this.$route.query.orderId;
        if (act === "success" && !_.isNil(orderId)) {
          this.paymentStatus({
            registerOrderId: orderId,
          }).then(() => {
            if (this.payStatusError) {
              const message =
                (this.payStatusError || {}).errorMessage ||
                "Ошибка получения статуса";
              this.$refs.alert.fail(message, "Платеж");
              this.$router.replace("/");
            } else {
              if (this.payStatusSuccess) {
                this.$refs.alert.ok(
                  `Успешно, сумма ${this.currency(this.paySum, {
                    withLabel: true,
                  })}`,
                  "Платеж"
                );
                this.fetchClient();
                this.$router.replace("/");
              } else {
                this.$refs.alert.ok("Успешно", "Платеж");
                this.fetchClient();
                this.$router.replace("/");
              }
            }
          });
        }
      }
      if (act === "fail") {
        this.$refs.alert.fail("Ошибка", "Платеж");
        this.$router.replace("/");
      }
    };

    this.$router.afterEach(paymentResultHook);
    paymentResultHook();
  },
};
</script>
